export const LOCALE = {
  en: {
    code: 'en',
    iso: 'en-US',
    algoliaSuffix: '',
    name: 'locale.en',
    serviceLanguageCode: 'en'
  },
  'fr-ca': {
    code: 'fr-ca',
    iso: 'fr-CA',
    algoliaSuffix: 'fr',
    name: 'locale.frCa',
    serviceLanguageCode: 'fr'
  }
}
